import { makeStyles } from '@mui/styles';
import { Typography } from 'apollo-react';
import FileUpload from 'apollo-react/components/FileUpload';
import Loader from 'apollo-react/components/Loader';
import Modal from 'apollo-react/components/Modal';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { saveCustomerLogoImage } from '../../../actions/CustomerLogoActions';
import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  modal: {
    width: 600,
  },
  errorMessage: {
    color: 'red',
    marginTop: 10,
    textAlign: 'center',
  },
});

const UploadCustomerLogo = ({ isUploadModalOpen, handleModalShowForUpload }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const dispatch = useDispatch();

  const [uploadErrorMessage, setUploadErrorMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [file, setFile] = useState([]);

  const allowedTypes = ['svg'];

  const handleFileChange = ([selectedFile]) => {
    if (!selectedFile) {
      return;
    }

    const fileType = _.last(selectedFile.name.split('.'));

    if (!allowedTypes.includes(fileType)) {
      setUploadErrorMessage('You can import only .svg file');
      return;
    }

    setUploadErrorMessage('');
    setFile([selectedFile]);
  };

  const handleSave = async () => {
    setIsUploading(true);

    await dispatch(saveCustomerLogoImage(file));

    setIsUploading(false);

    handleModalShowForUpload();
    setFile([]);
  };

  return (
    <Modal
      open={isUploadModalOpen}
      variant="default"
      onClose={handleModalShowForUpload}
      title={translateString('Upload a File')}
      buttonProps={[
        {
          label: translateString('Cancel'),
          'ui-ta': 'UploadFileModal-CancelButton',
        },
        {
          label: translateString('Upload'),
          onClick: handleSave,
          disabled: !file?.length,
          'ui-ta': 'UploadFileModal-UploadButton',
        },
      ]}
      className={classes.modal}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <FileUpload
        fullWidth
        value={file}
        label={`${translateString('Click browse to select a .svg file')}.`}
        accept="image/svg+xml"
        onUpload={handleFileChange}
        onFileDelete={() => setFile([])}
        maxItems={1}
        dropAreaLabels={{
          activeText: translateString('Drop here to upload!'),
          browseLinkText: translateString('browse').toLowerCase(),
          defaultText: translateString('Drag files here or '),
          hoverText: translateString('Click to browse'),
          maxText: translateString('You can import only one file'),
        }}
      />
      {uploadErrorMessage && (
        <Typography className={classes.errorMessage}>
          {translateString(uploadErrorMessage)}
        </Typography>
      )}
      {isUploading && <Loader isInner />}
    </Modal>
  );
};

export default UploadCustomerLogo;
